import React, { useState } from 'react';
import { X, Eye, EyeOff, Mail, CheckCircle } from 'lucide-react';
interface EmailUpdateModalProps {
  onClose: () => void;
  onSuccess: (email: string) => void;
  currentEmail: string;
}
export function EmailUpdateModal({
  onClose,
  onSuccess,
  currentEmail
}: EmailUpdateModalProps) {
  const [newEmail, setNewEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [verificationSent, setVerificationSent] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    // Basic email validation
    if (!/\S+@\S+\.\S+/.test(newEmail)) {
      setError('Geçerli bir e-posta adresi giriniz.');
      return;
    }
    // Check if new email is different from current email
    if (newEmail === currentEmail) {
      setError('Yeni e-posta adresi mevcut adresinizle aynı olamaz.');
      return;
    }
    // In a real app, we would call an API to send verification email
    // For now, we'll simulate sending a verification email
    setVerificationSent(true);
    // Simulate success after verification
    setTimeout(() => {
      onSuccess(newEmail);
      onClose();
    }, 5000);
  };
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-521">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-md" data-id="element-522">
        <div className="relative bg-black/90 rounded-xl p-6" data-id="element-523">
          <div className="flex justify-between items-center mb-6" data-id="element-524">
            <h2 className="text-xl font-bold" data-id="element-525">E-posta Güncelle</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-526">
              <X className="w-6 h-6" data-id="element-527" />
            </button>
          </div>
          {!verificationSent ? <form onSubmit={handleSubmit} className="space-y-4" data-id="element-528">
              <div className="space-y-2" data-id="element-529">
                <label className="block text-sm font-medium" data-id="element-530">
                  Mevcut E-posta
                </label>
                <input type="email" value={currentEmail} disabled className="w-full bg-white/5 text-gray-400 rounded-lg px-4 py-2.5 focus:ring-2 ring-purple-500/20" data-id="element-531" />
              </div>
              <div className="space-y-2" data-id="element-532">
                <label className="block text-sm font-medium" data-id="element-533">
                  Yeni E-posta Adresi
                </label>
                <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 focus:ring-2 ring-purple-500/20" required data-id="element-534" />
              </div>
              <div className="space-y-2" data-id="element-535">
                <label className="block text-sm font-medium" data-id="element-536">
                  Mevcut Şifre
                </label>
                <div className="relative" data-id="element-537">
                  <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-purple-500/20" required data-id="element-538" />
                  <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowPassword(!showPassword)} data-id="element-539">
                    {showPassword ? <EyeOff className="w-5 h-5" data-id="element-540" /> : <Eye className="w-5 h-5" data-id="element-541" />}
                  </button>
                </div>
              </div>
              {error && <p className="text-sm text-red-500" data-id="element-542">{error}</p>}
              <div className="pt-4 flex justify-end gap-3" data-id="element-543">
                <button type="button" onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-544">
                  İptal
                </button>
                <button type="submit" className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg hover:opacity-90 transition-opacity" data-id="element-545">
                  Güncelle
                </button>
              </div>
            </form> : <div className="text-center py-4 space-y-4" data-id="element-546">
              <div className="flex justify-center" data-id="element-547">
                <div className="w-16 h-16 bg-purple-500/20 rounded-full flex items-center justify-center" data-id="element-548">
                  <Mail className="w-8 h-8 text-purple-400" data-id="element-549" />
                </div>
              </div>
              <h3 className="text-lg font-medium" data-id="element-550">
                Doğrulama E-postası Gönderildi
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-551">
                {newEmail} adresine bir doğrulama linki gönderdik. Lütfen
                e-postanızı kontrol edin ve linke tıklayarak e-posta adresinizi
                doğrulayın.
              </p>
              <div className="text-xs text-gray-500 mt-4" data-id="element-552">
                Doğrulama linki 1 saat boyunca geçerlidir.
              </div>
              <div className="animate-pulse mt-4 flex justify-center" data-id="element-553">
                <CheckCircle className="w-6 h-6 text-green-500" data-id="element-554" />
              </div>
            </div>}
        </div>
      </div>
    </div>;
}